import actions from './actions';
import reducer from './reducer';

const otherPhysiciansCases = {
    actions,
    reducer,
    name: 'otherPhysiciansCases',
};

export default otherPhysiciansCases; 